import { passKeysApi } from 'api/passKeys';
import { startRegistration, startAuthentication }
  from '@simplewebauthn/browser';
import { reformatResponseDataForLoginSuccess } from 'api/userApi';
import { showAlert, updateProgress } from 'actions';
import { getLocalization } from 'global/global';
import { loginUserSuccess, setLoginSuccess } from './userActions';
import { getErrorMessage } from './loginUtils';

export const registerPasskey = () => {
  return async () => {
    const { publicKey } = await (await passKeysApi('/register/start')).json();
    let attResp;
    try {
      attResp = await startRegistration({ optionsJSON: publicKey });
    } catch (e: any) {
      if (e.name === 'InvalidStateError') {
        throw new Error('Passkey already registered on this device');
      }
      throw e;   // NotAllowedError = user cancelled
    }
    const res = await passKeysApi('/register/finish', attResp);
    if (!res.ok) {
      throw new Error('Registration failed');
    }
    return res;
  };
};

export const loginWithPasskey = (useAutofill: boolean = false, account: string, username?: string) => {
  return async (dispatch, getState) => {
    dispatch(updateProgress({ visible: true, message: getLocalization('loggingin') }));
    const { publicKey } = await (await passKeysApi('/login/start', { username })).json();
    console.log('found response');
    console.log(publicKey);
    try {
      const asseResp = await startAuthentication({
        optionsJSON: publicKey,
        useBrowserAutofill: useAutofill,
      });
      const res = await passKeysApi(`/login/finish?c=${account}`, asseResp);
      const json = await res.json();
      dispatch(updateProgress({ visible: false }));
      if (!res.ok) {
        dispatch(
          showAlert({
            visible: true,
            message: getErrorMessage(json.errorCode, json.errorMessage),
          }),
        );
      } else {
        const { clientPersist } = getState();
        const data = reformatResponseDataForLoginSuccess(json, false, clientPersist);
        setLoginSuccess(data, clientPersist, dispatch);
        dispatch(loginUserSuccess(data));
      }
    } catch (e) {
      dispatch(updateProgress({ visible: false }));
      console.log(e);
    }
  };
};
